export default {"src":"/stays/_next/static/media/SafetyAndSecurity.0fe8e08a.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};